module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-BoldItalic-0381a324a895e10c82fd9bc493ea6f16.otf";